import { EquipmentDmgFilterType } from '@/entities/equipment';
import { TDamageSchema } from '@/schemas/damage/damage.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapDmgFilterAPI } from '@/utils/map.utils';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const DAMAGE_URI = '/damage';

export const createNewDamage = async (damage: TDamageSchema) => {
  return requestApi({
    url: DAMAGE_URI,
    method: HTTP_METHOD.POST,
    body: damage,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingDamage = async (query?: TDamageSchema) => {
  let url = `${DAMAGE_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (query?.severity) {
    params.append('severity', query.severity.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllDamages = async () => {
  return requestApi({
    url: `${DAMAGE_URI}/allDamages`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const listAllUniqueDamages = async () => {
  return requestApi({
    url: `${DAMAGE_URI}/allUniqueDamages`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllDamages = async (
  filter: EquipmentDmgFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const filterMapped = mapDmgFilterAPI(filter);

  let url = `${DAMAGE_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveDamages = async () => {
  return requestApi({
    url: `${DAMAGE_URI}/totalActive`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getDamageById = async (id: string) => {
  return requestApi({
    url: `${DAMAGE_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getDamageByClassId = async (classId: number) => {
  return requestApi({
    url: `${DAMAGE_URI}/byClassId/${classId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getDamageByName = async (name: string) => {
  return requestApi({
    url: `${DAMAGE_URI}/byName/${name}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getDamageByNameAndSeverity = async (
  name: string,
  severity: number,
) => {
  return requestApi({
    url: `${DAMAGE_URI}/byNameAndSeverity/name/${name}/severity/${severity}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateDamage = async (damage: TDamageSchema) => {
  return requestApi({
    url: `${DAMAGE_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: damage,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyDamages = async (damages: TDamageSchema[]) => {
  return requestApi({
    url: `${DAMAGE_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: damages,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
